









import policyService from "@/services/policy.service"
import { Component, Vue } from "vue-property-decorator"
@Component({
    components: {},
    computed: {}
})
export default class HistoricalVersion extends Vue {
    preview_context = ""
    id = ""
    created() {
        this.getData()
    }

    mounted() {
        // 立即隐藏元素
        this.hideFormContainer()

        // 使用setTimeout确保在下一个事件循环中执行
        setTimeout(() => {
            this.hideFormContainer()
        }, 0)

        // 使用MutationObserver监听DOM变化
        this.observeFormContainer()
    }

    hideFormContainer() {
        const feFormElementsPC = document.getElementsByClassName("fe-form__container")
        if (feFormElementsPC.length > 0) {
            const feForm = feFormElementsPC[0] as HTMLElement
            feForm.style.display = "none"
            feForm.style.visibility = "hidden"
            feForm.style.opacity = "0"
        }
        const feFormElementsM = document.getElementsByClassName("fe_float-button")
        if (feFormElementsM.length > 0) {
            const feForm = feFormElementsM[0] as HTMLElement
            feForm.style.display = "none"
            feForm.style.visibility = "hidden"
            feForm.style.opacity = "0"
        }
    }

    observeFormContainer() {
        // 创建MutationObserver来监听DOM变化
        const observer = new MutationObserver(() => {
            this.hideFormContainer()
        })

        // 开始观察整个文档的变化
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["class", "style"]
        })

        // 在组件销毁时停止观察
        this.$once("hook:beforeDestroy", () => {
            observer.disconnect()
        })
    }

    async getData() {
        const id = this.$route.query.id || ""
        const res = await policyService.getPolicyOldVersion({
            id: id
        })
        this.preview_context = res || ""
    }
}
